import React from 'react'
import './roboBackground.css';
import roboBackground from '../Assets/robobg.png'
import robownage from '../Assets/robownage.PNG'
import robownage2 from '../Assets/robownage2.PNG'
import robownage3 from '../Assets/robownage3.PNG'
import robownage4 from '../Assets/robownage4.PNG'
import robownage5 from '../Assets/robownage5.PNG'
import robownage6 from '../Assets/robownage6.PNG'
import robownage7 from '../Assets/robownage7.PNG'

const RoboBackground = ({screenX, screenY}) => {
	return <div class="rbg">


		<div class="glitch">

			<img src={roboBackground} alt={"background"}/>
			<img src={roboBackground} alt={"background"}/>
			<img src={roboBackground} alt={"background"}/>
			<img src={roboBackground} alt={"background"}/>
			<img src={roboBackground} alt={"background"}/>
			<img src={roboBackground} alt={"background"}/>
			<img src={roboBackground} alt={"background"}/>
			<img src={roboBackground} alt={"background"}/>
			<img src={roboBackground} alt={"background"}/>
			<img src={roboBackground} alt={"background"}/>
			<img src={roboBackground} alt={"background"}/>
			<img src={roboBackground} alt={"background"}/>
			<div class="glitch__layers">
				<div class="glitch__layer"></div>
				<div class="glitch__layer"></div>
				<div class="glitch__layer"></div>
				<div class="glitch__layer"></div>
				<div class="glitch__layer"></div>
				<div class="glitch__layer"></div>
			</div>
		</div>

		


	<img src={robownage} alt={"robownage"} class={"robownage"}/>
	<img src={robownage2} alt={"robownage2"} class={"robownage robownage2"}/>
	<img src={robownage3} alt={"robownage3"} class={"robownage robownage3"}/>
	<img src={robownage4} alt={"robownage4"} class={"robownage robownage4"}/>
	<img src={robownage5} alt={"robownage5"} class={"robownage robownage5"}/>
	<img src={robownage6} alt={"robownage6"} class={"robownage robownage6"}/>
	<img src={robownage7} alt={"robownage7"} class={"robownage robownage7"}/>

	</div>
	
}

export default RoboBackground

